import { render, staticRenderFns } from "./TasProducerPaymentReport.vue?vue&type=template&id=0d91a972&scoped=true"
import script from "./TasProducerPaymentReport.vue?vue&type=script&lang=js"
export * from "./TasProducerPaymentReport.vue?vue&type=script&lang=js"
import style0 from "./TasProducerPaymentReport.vue?vue&type=style&index=0&id=0d91a972&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d91a972",
  null
  
)

export default component.exports